import { TabConfig } from './PageTabs';

export function getFirstVisibleTab<TabContentProps>(
  tabs: TabConfig<TabContentProps>[],
): TabConfig<TabContentProps> | undefined {
  return tabs.find(t => !t.hidden);
}
